import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const fvImage = document.querySelector('.c-fv__splide--main');
if (fvImage) {
  let fvTl = gsap.timeline({
    scrollTrigger: {
      scrub: 2,
      trigger: fvImage,
      start: 'top top+=104px',
      end: () => '+=' + (fvImage.clientHeight),
      invalidateOnRefresh: true,
    }
  })

  fvTl.add('start')
    .to(fvImage, {
      width: '10vw',
      top: -100,
    })

    .to('.c-fv__splide--text', {
      bottom: 167,
    }, '<')

    .to('.c-fv__img--back-text', {
      top: '80%'
    }, '<')
}